<ion-content class="no_padding store_details">
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else{
        @if(this.storeDashboard && this.storeDashboard.store){
            <ion-grid class="no_padding">
                <ion-row>
                    <ion-col class="no_padding">
                        <div class="title_card">{{'STORE_DETAILS' | translate}}</div> 
                    </ion-col>
                    <ion-col class="store_name" size="12" size-md="auto">
                        @if(this.retailerLogo){
                            <app-retailer-logo [retailer]="this.retailerLogo" />
                        }
                        <div>{{this.storeDashboard.store.name}}</div>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <marv-tabs [tabs]="this.tabsStore">
                <marv-tab tabId="infos">
                    @if(this.storeDetailsInfos){
                        <app-store-details-infos [store]="this.storeDetailsInfos" />
                    }
                </marv-tab>                 
                <marv-tab tabId="additional-data">
                    <app-store-details-additional-data [storeId]="this.storeDashboard.store.id" />
                </marv-tab>  
                <marv-tab tabId="missions">
                    <app-store-details-missions [storeId]="this.storeDashboard.store.id" [showDetailsMission]="this.showDetailsMission"/>
                </marv-tab>
                <marv-tab tabId="photos">
                    <app-store-details-photos [storeCode]="this.storeDashboard.store.code"/>
                </marv-tab>
            </marv-tabs>
        }
    }
</ion-content>
